import { optionStatusBin } from '../../../pages/daf/Adm/Dominios/utils/optionStatusBin';
import { ExportSheet } from '../core';
import { DataPreparer } from '../factory';

export class ListagemModuloItensExportPreparer implements DataPreparer {
  async prepareForExport(selectedItems: any[]): Promise<ExportSheet[]> {
    const mainSheetData = selectedItems.map((item) => ({
      id: item.id,
      status: optionStatusBin.find((opt) => opt.value === item.status)?.label,
      item: item.item,
      descricao: item.descricao,
      submodulo: item.submoduloNome,
      usuarioRegistro: item.usuarioRegistro?.nomeCompleto || 'N/A',
      dataRegistro: item.dataRegistro,
      dataUltimaAtualizacao: item.dataUltimaAtualizacao,
      usuarioAtualizacao: item.usuarioAtualizacao?.nomeCompleto || 'N/A',
      nEdicoes: item.nEdicoes || 0,
    }));

    const mainSheet: ExportSheet = {
      name: 'Listagem de Itens de Submódulo',
      columns: {
        id: 'ID',
        status: 'Status',
        item: 'Item',
        descricao: 'Descrição',
        submodulo: 'Submódulo',
        usuarioRegistro: 'Responsável pelo Registro',
        dataRegistro: 'Data de Registro',
        dataUltimaAtualizacao: 'Última Atualização',
        usuarioAtualizacao: 'Responsável Ult. Atualização',
        nEdicoes: 'Edições',
      },
      data: mainSheetData,
    };

    return [mainSheet];
  }
}
